export default {"src":"/_next/static/media/pet-profile-cup-icon.8361ebf5.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};